var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    width: "512px",
    height: "512px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface55147275"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,80.392158%,11.372549%)",
      fillOpacity: 1
    },
    d: "M 456 488 L 56 488 L 56 424 C 56 362.144531 106.144531 312 168 312 L 344 312 C 405.855469 312 456 362.144531 456 424 Z M 456 488 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.823529%,72.156864%,37.64706%)",
      fillOpacity: 1
    },
    d: "M 120 408 L 392 408 L 392 488 L 120 488 Z M 120 408 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.823529%,66.666669%,32.156864%)",
      fillOpacity: 1
    },
    d: "M 160 312.402344 C 146.125 313.375 132.558594 316.945312 120 322.921875 L 120 408 L 160 408 Z M 160 312.402344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,79.215688%,60.000002%)",
      fillOpacity: 1
    },
    d: "M 304 312 C 304 312 296 336 256 336 C 216 336 208 312 208 312 L 208 264 L 304 264 Z M 304 312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,79.215688%,60.000002%)",
      fillOpacity: 1
    },
    d: "M 168 224 L 208 224 L 208 168 L 152 168 C 143.164062 168 136 175.164062 136 184 L 136 192 C 136 209.671875 150.328125 224 168 224 Z M 168 224 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,79.215688%,60.000002%)",
      fillOpacity: 1
    },
    d: "M 344 224 L 304 224 L 304 168 L 360 168 C 368.835938 168 376 175.164062 376 184 L 376 192 C 376 209.671875 361.671875 224 344 224 Z M 344 224 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,83.529413%,65.098041%)",
      fillOpacity: 1
    },
    d: "M 176 168 L 336 168 L 336 208 C 336 252.183594 300.183594 288 256 288 C 211.816406 288 176 252.183594 176 208 Z M 176 168 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.823529%,72.156864%,37.64706%)",
      fillOpacity: 1
    },
    d: "M 240 24 L 272 24 C 316.183594 24 352 59.816406 352 104 L 352 136 L 160 136 L 160 104 C 160 59.816406 195.816406 24 240 24 Z M 240 24 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,80.392158%,11.372549%)",
      fillOpacity: 1
    },
    d: "M 160 104 L 352 104 L 352 136 L 160 136 Z M 160 104 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.823529%,72.156864%,37.64706%)",
      fillOpacity: 1
    },
    d: "M 104 136 L 408 136 L 408 151.085938 C 408 160.425781 400.425781 168 391.085938 168 L 120.914062 168 C 111.574219 168 104 160.425781 104 151.085938 Z M 104 136 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(4.705882%,74.901962%,14.117648%)",
      fillOpacity: 1
    },
    d: "M 356.894531 312.796875 C 402.226562 331.128906 431.925781 375.101562 432 424 L 432 488 L 456 488 L 456 424 C 455.984375 367.148438 413.371094 319.332031 356.894531 312.796875 Z M 356.894531 312.796875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,79.215688%,60.000002%)",
      fillOpacity: 1
    },
    d: "M 336 208 L 336 168 L 312 168 L 312 208 C 311.957031 242.253906 292.039062 273.367188 260.953125 287.75 C 303.109375 285.167969 335.980469 250.234375 336 208 Z M 336 208 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.823529%,66.666669%,32.156864%)",
      fillOpacity: 1
    },
    d: "M 276.964844 24.25 C 308.039062 38.644531 327.949219 69.753906 328 104 L 328 136 L 352 136 L 352 104 C 351.980469 61.769531 319.117188 26.839844 276.964844 24.25 Z M 276.964844 24.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(4.705882%,74.901962%,14.117648%)",
      fillOpacity: 1
    },
    d: "M 328 104 L 352 104 L 352 136 L 328 136 Z M 328 104 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.823529%,66.666669%,32.156864%)",
      fillOpacity: 1
    },
    d: "M 408 151.085938 L 408 136 L 384 136 L 384 151.085938 C 383.984375 157.375 381.578125 163.421875 377.269531 168 L 391.085938 168 C 395.570312 168 399.875 166.21875 403.046875 163.046875 C 406.21875 159.875 408 155.570312 408 151.085938 Z M 408 151.085938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.823529%,66.666669%,32.156864%)",
      fillOpacity: 1
    },
    d: "M 352 312.402344 C 365.875 313.375 379.441406 316.945312 392 322.921875 L 392 408 L 352 408 Z M 352 312.402344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.823529%,61.960787%,22.745098%)",
      fillOpacity: 1
    },
    d: "M 392 322.921875 C 381.875 318.136719 371.089844 314.910156 360 313.351562 L 360 314.007812 C 371.703125 319.160156 382.507812 326.152344 392 334.722656 Z M 392 322.921875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 344 304 L 312 304 L 312 275.828125 C 325.746094 264.449219 335.714844 249.164062 340.589844 232 L 344 232 C 366.082031 231.972656 383.972656 214.082031 384 192 L 384 184 C 383.972656 181.269531 383.472656 178.5625 382.527344 176 L 391.085938 176 C 404.839844 175.984375 415.984375 164.839844 416 151.085938 L 416 136 C 416 131.582031 412.417969 128 408 128 L 360 128 L 360 104 C 359.945312 55.421875 320.578125 16.054688 272 16 L 240 16 C 191.421875 16.054688 152.054688 55.421875 152 104 L 152 128 L 104 128 C 99.582031 128 96 131.582031 96 136 L 96 151.085938 C 96.015625 164.839844 107.160156 175.984375 120.914062 176 L 129.472656 176 C 128.527344 178.5625 128.027344 181.269531 128 184 L 128 192 C 128.027344 214.082031 145.917969 231.972656 168 232 L 171.410156 232 C 176.285156 249.164062 186.253906 264.449219 200 275.828125 L 200 304 L 168 304 C 101.757812 304.074219 48.074219 357.757812 48 424 L 48 488 C 48 492.417969 51.582031 496 56 496 L 456 496 C 460.417969 496 464 492.417969 464 488 L 464 424 C 463.925781 357.757812 410.242188 304.074219 344 304 Z M 128 400 L 128 328.023438 C 135.703125 324.839844 143.761719 322.605469 152 321.363281 L 152 400 Z M 128 416 L 384 416 L 384 480 L 128 480 Z M 384 400 L 360 400 L 360 321.363281 C 368.238281 322.605469 376.296875 324.839844 384 328.023438 Z M 368 184 L 368 192 C 367.984375 205.25 357.25 215.984375 344 216 L 343.59375 216 C 343.835938 213.359375 344 210.699219 344 208 L 344 176 L 360 176 C 364.414062 176.003906 367.996094 179.585938 368 184 Z M 240 32 L 272 32 C 308.644531 32.050781 339.417969 59.585938 343.527344 96 L 168.472656 96 C 172.582031 59.585938 203.355469 32.050781 240 32 Z M 168 112 L 344 112 L 344 128 L 168 128 Z M 112 151.085938 L 112 144 L 400 144 L 400 151.085938 C 399.992188 156.007812 396.007812 159.992188 391.085938 160 L 120.914062 160 C 115.992188 159.992188 112.007812 156.007812 112 151.085938 Z M 168 216 C 154.75 215.984375 144.015625 205.25 144 192 L 144 184 C 144.003906 179.585938 147.585938 176.003906 152 176 L 168 176 L 168 208 C 168 210.699219 168.164062 213.359375 168.40625 216 Z M 184 208 L 184 176 L 328 176 L 328 208 C 328 247.765625 295.765625 280 256 280 C 216.234375 280 184 247.765625 184 208 Z M 256 296 C 269.917969 295.996094 283.632812 292.664062 296 286.285156 L 296 310.355469 C 294.027344 314.269531 285.035156 328 256 328 C 226.820312 328 217.882812 314.132812 216 310.378906 L 216 286.285156 C 228.367188 292.664062 242.082031 295.996094 256 296 Z M 203.136719 320 C 208.390625 328.535156 222.511719 344 256 344 C 289.488281 344 303.609375 328.535156 308.863281 320 L 344 320 L 344 400 L 168 400 L 168 320 Z M 64 424 C 64.035156 388.558594 82.125 355.574219 112 336.503906 L 112 480 L 64 480 Z M 448 480 L 400 480 L 400 336.503906 C 429.875 355.574219 447.964844 388.558594 448 424 Z M 448 480 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5f2fd8331891cd4824a7819d2b19c552.svg";
export { ForwardRef as ReactComponent };